import Season from '@src/resources/Season';

export const redirect = (basePath: string, id: string, data: any) =>
  `/${Season.name}/${data.season_id}/show/episodes`;
